import { Mail, MessageCircle, MapPin, Clock, Phone } from "lucide-react";
import { CONTACT, WHATSAPP_URL, MAILTO_URL } from "@/lib/constants";

const Contact = () => {
    return (
        <section
            id="contacto"
            data-testid="contact-section"
            className="border-b border-white/10 relative overflow-hidden"
        >
            <div className="absolute inset-0 bg-blueprint opacity-25 pointer-events-none" />

            <div className="relative px-6 md:px-12 lg:px-16 py-20 md:py-28">
                <p className="text-xs md:text-sm font-mono tracking-[0.3em] uppercase text-white/50 mb-6">
                    / 006 — Contacto
                </p>

                <h2
                    data-testid="contact-headline"
                    className="font-display uppercase tracking-tighter leading-[0.82] text-[18vw] md:text-[15vw]"
                >
                    Hablemos
                    <span className="text-[#1A9EC9]">.</span>
                </h2>

                <p className="mt-10 font-mono text-base md:text-lg text-white/70 max-w-2xl leading-relaxed">
                    Contáctanos por WhatsApp para una respuesta inmediata o
                    escríbenos por correo si tu proyecto requiere más detalle.
                </p>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="contact-whatsapp-btn"
                        className="group flex items-center justify-between gap-6 bg-[#25D366] hover:bg-white text-black px-8 py-7 transition-colors"
                    >
                        <div className="flex items-center gap-4">
                            <MessageCircle size={26} />
                            <div className="text-left">
                                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-black/60">
                                    WhatsApp · Respuesta inmediata
                                </div>
                                <div className="font-display uppercase text-xl md:text-2xl tracking-tight">
                                    Chatear ahora
                                </div>
                            </div>
                        </div>
                        <span className="font-display text-2xl">→</span>
                    </a>

                    <a
                        href={MAILTO_URL}
                        data-testid="contact-email-btn"
                        className="group flex items-center justify-between gap-6 border border-white/20 hover:bg-white hover:text-black px-8 py-7 transition-colors"
                    >
                        <div className="flex items-center gap-4">
                            <Mail size={26} />
                            <div className="text-left">
                                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/50 group-hover:text-black/60">
                                    Correo · Cotización formal
                                </div>
                                <div className="font-display uppercase text-xl md:text-2xl tracking-tight">
                                    Enviar email
                                </div>
                            </div>
                        </div>
                        <span className="font-display text-2xl">→</span>
                    </a>
                </div>

                {/* Contact details strip */}
                <div className="mt-20 grid grid-cols-1 md:grid-cols-4 border-l border-t border-white/10">
                    <Detail
                        icon={<Phone size={18} />}
                        label="Teléfono"
                        value={CONTACT.phone}
                        testid="detail-phone"
                    />
                    <Detail
                        icon={<Mail size={18} />}
                        label="Email"
                        value={CONTACT.email}
                        testid="detail-email"
                    />
                    <Detail
                        icon={<MapPin size={18} />}
                        label="Oficina"
                        value={`${CONTACT.address}, ${CONTACT.city}`}
                        testid="detail-address"
                    />
                    <Detail
                        icon={<Clock size={18} />}
                        label="Horario"
                        value={CONTACT.hours}
                        testid="detail-hours"
                    />
                </div>
            </div>
        </section>
    );
};

const Detail = ({ icon, label, value, testid }) => (
    <div
        data-testid={testid}
        className="border-r border-b border-white/10 p-8 flex flex-col gap-4"
    >
        <div className="text-[#1A9EC9]">{icon}</div>
        <div>
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 mb-2">
                {label}
            </div>
            <div className="font-display uppercase text-base md:text-lg tracking-tight text-white break-words">
                {value}
            </div>
        </div>
    </div>
);

export default Contact;
